import { Container, ContainerProps, styled } from '@mui/material';

export const ContentContainer = styled(Container)<ContainerProps>`
  height: 100%;
  overflow: auto;
  padding: 0 42px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 0 24px;
  }
`;
